import { FC } from 'react'
import { buttonStyle, useSnackbar } from '@expane/widgets'
import { useCreateBusinessAnonymously } from '@expane/logic/useCreateBusinessAnonymously'
import { firebase } from 'services/firebase'
import { reloadApp } from 'logic/app'
import { getLeadIdFromCookie } from '@expane/web-logic/leadGeneration'
import { config } from 'config'
import { Button } from '@expane/ui'
import { useTranslation } from 'react-i18next'
import { IoRocketOutline } from 'react-icons/io5'
import { FEATURE_FLAGS, useFeatureFlags } from '@expane/logic/featureFlags'

export const TryWithoutRegistrationWidget: FC = () => {
  const { t } = useTranslation()

  const [openSnackbar] = useSnackbar()

  const { getFeatureFlag } = useFeatureFlags()
  const isEnabledCreateBusinessAnonymously = getFeatureFlag(
    FEATURE_FLAGS.enabledCreateBusinessAnonymously,
  )

  const { createBusinessAnonymously, isLoading } = useCreateBusinessAnonymously({
    signInAnonymously: firebase.signInAnonymously,
    onSuccess: reloadApp,
    onError: () => openSnackbar(t('submitError'), 'error'),
    getLeadId: () => getLeadIdFromCookie(config),
  })

  return isEnabledCreateBusinessAnonymously ? (
    <>
      <p className="mt-6 mb-2 text-center text-secondary-color">{t('ifDontHaveAccount')}:</p>
      <Button
        Icon={IoRocketOutline}
        className={buttonStyle}
        onClick={createBusinessAnonymously}
        disabled={isLoading}
        spinner={isLoading}
      >
        {t('tryWithoutRegistration')}
      </Button>
    </>
  ) : null
}
